
import axios from './api/posts';
import {useNavigate} from 'react-router-dom';
import {useState} from 'react'

import Spinner from 'react-bootstrap/Spinner';

function LoginUI({setAccessToken,setIsAuthenticated,userFullName,setUserFullName,refreshFailed,setRefreshFailed}){
  const [userName,setUserName]=useState('');
  const [password,setPassword]=useState('');
  const navigate=useNavigate();
  const [isLoading,setIsloading]=useState(false);
  const [otpError,setOtpError]=useState('');
  const [showSendOtp,setShowSendOtp]=useState(true);
  async function onUserNameChange(e)
  {
    setUserName(e.target.value);
    setOtpError('');
  }
  async function onPasswordChange(e)
  {
    setPassword(e.target.value)
    if(e.target.value&&e.target.value.length>0)
    {
      setShowSendOtp(false);
    }
    else{
      setShowSendOtp(true);
    }
  }
  
  async function handleLogin(e)
    {
      e.preventDefault();
      setIsloading(true);
      try{
            const config = { withCredentials: true };
            const data=await axios.post('/login',{
            userName:userName,
            password:password
            },config);
            setAccessToken(data['data']['accesstoken']);
            setUserFullName(data['data']['userFullName']);
            setIsAuthenticated(true);
            setRefreshFailed(false);
            setUserName('');
            setPassword('');
            //alert(JSON.stringify(data));
            navigate('/');   
                       
      }
      catch(err)
      {
        //alert(err);
        setAccessToken('');
        setIsAuthenticated(false);
        setRefreshFailed(true);
        alert('Login failed!');
      }
      finally
      {
        setIsloading(false);     
      }
    }
    async function handleSendOTP(e)
    {
      e.preventDefault();
      setIsloading(true);
      setOtpError('');
      try{
            const config = { withCredentials: true };
            const data=await axios.post('/login/sendOTP',{
            userName:userName,
            password:password
            },config);
            
            setOtpError(`OTP emailed TO ${userName}`);
                       
      }
      catch(err)
      {
        setOtpError(err&&err.response&&err.response.data&&err.response.data.error?err.response.data.error:'OOPS! something went wrong!');
        setAccessToken('');
        setIsAuthenticated(false);
        setRefreshFailed(true);
        //alert('Login failed!');
      }
      finally
      {
        setIsloading(false);     
      }
    }   
    return (  
      <main>
        <form className="loginForm">
          <div className="loginDiv">
            <label>User Name:</label>
            <input className="borderLess" type='text' placeholder="Registered email id" onChange={(e)=>{onUserNameChange(e)}} value={userName}></input>
            <label className="marginTop">Password</label>
            <input className="borderLess" type='password' placeholder="Password or OTP" onChange={(e)=>{onPasswordChange(e)}} value={password}></input>
            <div className="marginTop fullWidth loginButtonyNav">
              {showSendOtp && <button className="btn btn-success" name='btnLogin' onClick={handleSendOTP}>SEND ME AN OTP</button>}              
              {!showSendOtp && <button className="btn btn-primary" disabled name='btnLogin' onClick={handleSendOTP}>SEND ME AN OTP</button>}              
              <button className="btn btn-primary" name='btnLogin' onClick={handleLogin}>LOGIN</button></div>
              <div className='verticalDiv centeredDiv fullWidth'>{otpError &&
                <p>{otpError}</p>
                }</div>
          </div>
        </form>
        
        {isLoading && 
        <div className='spinneroverlay'>
          <div className='spinnerbody'>
            <Spinner animation="border" variant="info" />
            <p>Please wait. It might take a few seconds.</p>
          </div>           
        </div>}
      </main> 

       );
}
export default LoginUI;
